<template>
  <div>
    <add-payment-type :is-active.sync="isAdding" @changed="paymentTypeAdded" />
    <add-payment-type
      :is-active.sync="isUpdating"
      method="put"
      :paymentType="editingType"
      @changed="paymentTypeUpdated"
    />
    <data-table title="Payment Types" :url="url" :headers="headers" ref="table" searchable>
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          <v-icon color="light-blue lighten-4">
            mdi-plus-outline
          </v-icon>
          Add Payment Type
        </v-btn>
      </template>
      <template slot="item.actions" slot-scope="{ item }">
        <v-icon medium title="Edit Payment Type" @click.stop="updateType(item)">
          mdi-pencil
        </v-icon>
      </template>
    </data-table>
  </div>
</template>

<script>
import AddPaymentType from "./form";

export default {
  components: { AddPaymentType },
  data() {
    return {
      isAdding: false,
      isUpdating: false,
      url: "/api/v1/transactions/cryptoPaymentTypes",
      editingType: null,
      headers: {
        name: "Name",
        actions: "Actions",
      },
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    paymentTypeAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    paymentTypeUpdated({ message }) {
      this.editingType = null;
      this.isUpdating = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    updateType(type) {
      this.editingType = Object.assign({}, type);
      this.isUpdating = true;
    },
    // showDetails({ id }) {
    //   this.$router.push({ name: "transfer.paymentTypes.show", params: { id } });
    // },
  },
};
</script>
